import Input from '@eduzz/houston-ui/Forms/Input';
import Checkbox from '@material-ui/core/Checkbox';
import IconButton from '@material-ui/core/IconButton';
import Paper from '@material-ui/core/Paper';
import type { StyledComponentProps } from '@material-ui/core/styles';
import { withStyles } from '@material-ui/core/styles';
import { lighten } from '@material-ui/core/styles/colorManipulator';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import Toolbar from '@material-ui/core/Toolbar';
import Tooltip from '@material-ui/core/Tooltip';
import Typography from '@material-ui/core/Typography';
import ClearIcon from '@material-ui/icons/Clear';
import classNames from 'classnames';
import React from 'react';
import { connect } from 'react-redux';
import { listConnectProducts } from 'store/Orbita/Connect/actions';
import Truncate from 'v2/components/Shared/TruncateText';

import type { DispatchProp } from 'react-redux';

interface IProps extends DispatchProp<any>, StyledComponentProps {
  newAction: any;
  products: any;
}

const rows = [{ id: 'name', numeric: false, disablePadding: true, label: 'Produto' }];

class EnhancedTableHead extends React.Component<any, any> {
  createSortHandler = (property: any) => (event: any) => {
    this.props.onRequestSort(event, property);
  };

  render() {
    const { onSelectAllClick, numSelected, rowCount } = this.props;

    return (
      <TableHead>
        <TableRow>
          <TableCell padding='checkbox'>
            <Checkbox indeterminate={numSelected > 0 && numSelected < rowCount} checked={numSelected === rowCount} onChange={onSelectAllClick} />
          </TableCell>
          {rows.map((row) => {
            return (
              <TableCell key={row.id} padding={row.disablePadding ? 'none' : 'default'}>
                <Tooltip title='Sort' placement={row.numeric ? 'bottom-end' : 'bottom-start'} enterDelay={300}>
                  <TableSortLabel onClick={() => this.createSortHandler(row.id)}>{row.label}</TableSortLabel>
                </Tooltip>
              </TableCell>
            );
          })}
        </TableRow>
      </TableHead>
    );
  }
}

const styles = withStyles((theme: any) => ({
  root: {
    width: '100%',
  },
  table: {
    width: '100%',
  },
  tableWrapper: {
    width: '100%',
    overflowY: 'auto',
    height: '40vh',
  },
  highlight:
    theme.palette.type === 'light'
      ? {
          color: theme.palette.secondary.main,
          backgroundColor: lighten(theme.palette.secondary.light, 0.85),
        }
      : {
          color: theme.palette.text.primary,
          backgroundColor: theme.palette.secondary.dark,
        },
  spacer: {
    flex: '1 1 100%',
  },
  actions: {
    color: theme.palette.text.secondary,
  },
  title: {
    flex: '0 0 auto',
  },
}));

class EnhancedTable extends React.Component<IProps, { filter: any }> {
  constructor(props: IProps) {
    super(props);
    this.state = {
      filter: '',
    };
    props.dispatch(listConnectProducts());
  }

  handleSelectAllClick = (event: any) => {
    let newAction = this.props.newAction;
    if (event.target.checked) {
      newAction.products_id = this.props.products.map((n: any) => n.id);
      this.props.dispatch({ type: 'CHANGE_NEW_ACTION', newAction });
      return;
    }
    newAction.products_id = [];
    this.props.dispatch({ type: 'CHANGE_NEW_ACTION', newAction });
  };

  handleClick = (event: any, id: any) => {
    let newAction = this.props.newAction;
    if (Array.isArray(newAction.products_id)) {
      const index = newAction.products_id.indexOf(id);
      if (index === -1) {
        newAction.products_id.push(id);
      } else {
        newAction.products_id.splice(index, 1);
      }
    } else {
      newAction.products_id = [id];
    }
    this.props.dispatch({ type: 'CHANGE_NEW_ACTION', newAction });
  };

  isSelected = (id: any) => Array.isArray(this.props.newAction.products_id) && this.props.newAction.products_id.indexOf(id) !== -1;
  render() {
    const { classes, products } = this.props;
    const selectedProducts = this.props.newAction.products_id || [];
    const filter = this.state.filter;
    const listProducts = Array.isArray(products) ? products : [];
    const filteredProducts = listProducts.filter((p: any) => {
      if (!filter || (filter && filter === '')) return true;
      if (p?.title.toLowerCase().includes(filter.toLowerCase())) return true;
      if (p.id == filter) return true;
      return false;
    });

    return (
      <Paper className={classes.root} elevation={0}>
        <Input label='Buscar' value={filter} fullWidth onChange={(e) => this.setState({ filter: e })} />
        <Toolbar
          className={classNames(classes.root, {
            [classes.highlight]: selectedProducts.length > 0,
          })}
        >
          <div className={classes.title}>
            {selectedProducts.length > 0 ? (
              <Typography color='inherit'>
                {selectedProducts.length === 1
                  ? `${selectedProducts.length} produto selecionado`
                  : `${selectedProducts.length} produtos selecionados`}
              </Typography>
            ) : (
              <Typography id='tableTitle'>Selecione os produtos</Typography>
            )}
          </div>
          <div className={classes.spacer} />
          <div className={classes.actions}>
            {selectedProducts.length > 0 ? (
              <Tooltip title='Deselecionar'>
                <IconButton aria-label='Deselecionar' onClick={this.handleSelectAllClick}>
                  <ClearIcon />
                </IconButton>
              </Tooltip>
            ) : null}
          </div>
        </Toolbar>
        <div className={classes.tableWrapper}>
          <Table className={classes.table} aria-labelledby='tableTitle'>
            <EnhancedTableHead
              numSelected={selectedProducts.length}
              onSelectAllClick={this.handleSelectAllClick}
              rowCount={Array.isArray(products) ? products.length : 0}
            />
            <TableBody>
              {filteredProducts.map((prod: any) => {
                const isSelected = this.isSelected(prod.id);
                return (
                  <TableRow
                    hover
                    onClick={(event) => this.handleClick(event, prod.id)}
                    role='checkbox'
                    aria-checked={isSelected}
                    tabIndex={-1}
                    key={prod.id}
                    selected={isSelected}
                  >
                    <TableCell padding='checkbox'>
                      <Checkbox checked={isSelected} />
                    </TableCell>
                    <TableCell component='th' scope='row' padding='none'>
                      <strong>{prod.id}</strong>
                      <Truncate count={50} final='...'>
                        {prod.title}
                      </Truncate>
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </div>
      </Paper>
    );
  }
}

function mapStateToProps(state: any) {
  return {
    products: state.orbita.Connect.listConnectProduct,
    newAction: state.components.Connect.newAction,
  };
}

export default connect(mapStateToProps)(styles(EnhancedTable));
